export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = `${LOGIN}_SUCCESS`;
export const LOGIN_ERROR = `${LOGIN}_ERROR`;
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_SUCCESS = `${EDIT_PROFILE}_SUCCESS`;
export const EDIT_PROFILE_ERROR = `${EDIT_PROFILE}_ERROR`;

export const PERMISSIONS = 'PERMISSIONS';
export const GET_LOGGED_USER = 'GET_LOGGED_USER';
export const GET_LOGGED_USER_SUCCESS = `${GET_LOGGED_USER}_SUCCESS`;

export const loginAction = payload => ({
  type: LOGIN,
  payload,
});

export const logoutAction = {
  type: LOGOUT,
};

export const getLoggedUserAction = {
  type: GET_LOGGED_USER,
};

export const editProfileAction = payload => ({
  type: EDIT_PROFILE,
  payload,
});
